import React, { useState } from "react";
import { CATEGORIES_API } from "../../../Utilities/APIs";

import Form from "../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import ImageInput from "../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import useAxiosInstance from "../../../Utilities/Hooks/useAxiosInstance";

function CreateCategory({ setShowCreateForm, setShowModal, triggerFetch }) {
  const [name, setName] = useState("");
  const [precedence, setPrecedence] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const axiosInstance = useAxiosInstance();

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();

    itemData.append("name", name);
    itemData.append("precedence", precedence);
    itemData.append("image", image);
    itemData.append("description", description);
    itemData.append("backgroundColor", backgroundColor);

    const response = await axiosInstance.post(CATEGORIES_API, itemData);

    if (response) {
      setShowCreateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ShortTextInput
        label={`Name`}
        value={name}
        placeholder={`Category Name`}
        setState={setName}
      />
      <ShortTextInput
        label={`Precedence`}
        value={precedence}
        placeholder={`Enter precedence`}
        setState={setPrecedence}
      />
      <ShortTextInput
        label={`Description`}
        value={description}
        placeholder={`Enter Description`}
        setState={setDescription}
      />
      <ShortTextInput
        label={`BackgroundColor`}
        value={backgroundColor}
        placeholder={`Enter BackgroundColor`}
        setState={setBackgroundColor}
      />

      <ImageInput
        fieldId="1"
        state={image}
        setState={setImage}
        allowCreateImage
      >
        Upload Category Image
      </ImageInput>
      <FormSubmitButton text="Create" />
    </Form>
  );
}

export default CreateCategory;
